module.exports = __webpack_public_path__ + "img/pop_bg.7dfdd176.png";